import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { themeMapping, baseTheme, darkTheme } from 'theme';

type AppDrawerStyleProps = {
  themeMode: 'light' | 'dark';
};

const getTheme = (themeMode: 'light' | 'dark') => {
  const envTheme = themeMapping[import.meta.env.VITE_ENVIRONMENT];
  return themeMode === 'light' ? envTheme || baseTheme : darkTheme;
};

export const useAppDrawerStyles = makeStyles<Theme, AppDrawerStyleProps>(_theme => ({
  root: props => {
    const currentTheme = getTheme(props.themeMode);

    return {
      '& .MuiPaper-root': {
        paddingRight: '3px',
        '& > .MuiButton-root': {
          top: '4.5rem',
          right: '-1.1rem',
          width: '2.2rem',
          minWidth: '2.2rem',
          height: '2.2rem',
        },
      },
      '& .MuiListItem-root': {
        paddingTop: '2px',
        paddingBottom: '2px',
        borderRadius: '4px',
      },
      '& .MuiListSubheader-root': {
        color: currentTheme.palette.text.primary,
      },
      '& .MuiButton-containedPrimary': {
        '&:hover': {
          backgroundColor: currentTheme.palette.primary.dark,
          color:
            currentTheme.palette.mode === 'light'
              ? currentTheme.palette.common.white
              : currentTheme.palette.common.black,
        },
        backgroundColor: currentTheme.palette.primary.main,
        color:
          currentTheme.palette.mode === 'light'
            ? currentTheme.palette.common.white
            : currentTheme.palette.common.black,
      },
      '& .MuiListItemText-primary': {
        fontWeight: currentTheme.typography.fontWeightBold,
      },
      '& .MuiSvgIcon-root': {
        width: '20px',
      },
      '& .MuiListItemIcon-root': {
        minWidth: '36px',
      },
      '& .MuiListItem-root.Mui-selected': {
        '& .MuiListItemIcon-root': {
          color:
            currentTheme.palette.mode === 'dark'
              ? currentTheme.palette.common.black
              : currentTheme.palette.common.white,
        },
        backgroundColor: currentTheme.palette.primary.main,
        border: `0.2px solid ${currentTheme.palette.primary.main}`,
        color:
          currentTheme.palette.mode === 'dark'
            ? currentTheme.palette.common.black
            : currentTheme.palette.common.white,

        '&:hover': {
          backgroundColor: currentTheme.palette.primary.dark,
          border: `0.2px solid ${currentTheme.palette.primary.dark}`,
        },
      },
    };
  },
}));

export const appDrawerStyles = {
  sportSelect: {
    margin: '0.5rem 0 1rem 0.5rem',
    width: '14.3rem',
  },
};
